import api from './axios';

export const getProfileApi           = ()         => api.get('/users/profile');
export const updateProfileApi        = (data)     => api.put('/users/profile', data);
export const changePasswordApi       = (data)     => api.put('/users/change-password', data);
export const updateNotificationsApi  = (data)     => api.put('/users/notifications', data);

export const getAddressesApi         = ()         => api.get('/users/addresses');
export const addAddressApi           = (data)     => api.post('/users/addresses', data);
export const updateAddressApi        = (id, data) => api.put(`/users/addresses/${id}`, data);
export const setDefaultAddressApi    = (id)       => api.patch(`/users/addresses/${id}/set-default`);
export const deleteAddressApi        = (id)       => api.delete(`/users/addresses/${id}`);

export const getWishlistApi          = ()         => api.get('/users/wishlist');
export const addToWishlistApi        = (data)     => api.post('/users/wishlist', data);
export const removeWishlistApi       = (id)       => api.delete(`/users/wishlist/${id}`);

export const getUserCouponsApi       = ()         => api.get('/users/coupons');
